(() => {
  let showUnavailable = new URLSearchParams(location.search).getAll('filter.v.availability').includes('0');
  let view = 'grid';
  try { view = localStorage.getItem('p5-live-view') || 'grid'; } catch (_) {}
  if (!['grid', 'compact', 'list'].includes(view)) view = 'grid';
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  function updateCatalogue(root) {
    const toolbar = root.querySelector('[data-p5-toolbar]');
    if (!toolbar) return;
    const mobileFilter = toolbar.querySelector('[data-p5-mobile-filter]');
    if (mobileFilter) mobileFilter.hidden = !document.getElementById('facets-drawer');
    const cards = [...root.querySelectorAll('product-list > product-card')];
    const category = new URLSearchParams(location.search).get('p5_category');
    const taxonomyNode = root.querySelector('[data-p5-taxonomy]');
    const labelsNode = root.querySelector('[data-p5-taxonomy-labels]');
    if(category && taxonomyNode && labelsNode){
      const reference=JSON.parse(taxonomyNode.textContent),labels=JSON.parse(labelsNode.textContent);
      const known=['skim','surf','performance-skim','premium-skim','ltd-skim','hybrid','performance-surf','fun-surf','stealth-surf','skim-fins','surf-fins','board-bags'];
      if(known.includes(category)){
        const heading=document.querySelector('main h1');if(heading)setText(heading,labels[category]||labels[category==='board-bags'?'bags':category]);
        for(const card of cards){
          const title=card.dataset.p5Title||'',upper=title.toUpperCase(),tags=JSON.parse(card.dataset.p5Tags||'[]').map(t=>t.toUpperCase());
          let family=upper.replace(/^\s*20\d{2}\s+/,'').replace(/^THE\s+/,'').replace(/^PHASE\s*(?:FIVE|5)\s+/,'').replace(/\s+BLEM$/,'').trim();
          family=reference.aliases[family]||family;const row=reference.rows.find(r=>r.family===family);const groups=[];
          const isBoard=tags.includes('BOARDS')&&!tags.includes('GIFT VOUCHER')&&!upper.includes('GIFT');
          const hybrid=/^(SWITCHBLADE|FIREBALL)( |$)/.test(family);
          if(isBoard && (hybrid||(row?row.style==='Skim':tags.includes('SKIM')&&!tags.includes('SURF'))) && !tags.includes('FOIL')){
            groups.push('skim');if(upper.includes('LTD'))groups.push('ltd-skim');else if(hybrid)groups.push('hybrid');else groups.push(Number(card.dataset.p5Regular)<100000?'performance-skim':'premium-skim');
          }
          if(isBoard && !hybrid && (row?row.style==='Surf':tags.includes('SURF')) && !tags.includes('FOIL')){
            groups.push('surf');if(row?.category==='Fun Surf Style')groups.push('fun-surf');else if(row?.category==='Stealth Surf Style'||tags.includes('STEALTH SURF'))groups.push('stealth-surf');else if(row?.category==='Performance Surf Style'||tags.includes('PERFORMANCE SURF'))groups.push('performance-surf');
          }
          if((tags.includes('FINS')||upper.includes('FIN'))&&(tags.includes('SKIM')||upper.includes('SKIM')))groups.push('skim-fins');
          if((tags.includes('FINS')||upper.includes('FIN'))&&(tags.includes('SURF')||upper.includes('SURF')))groups.push('surf-fins');
          if(upper.includes('BAG')&&(upper.includes('BOARD')||upper.includes('SURF')||upper.includes('SKIM')))groups.push('board-bags');
          card.toggleAttribute('data-p5-category-hidden',!groups.includes(category));
        }
      }
    }
    root.dataset.showUnavailable = String(showUnavailable);
    root.dataset.layout = view;
    toolbar.querySelector('[data-p5-show-unavailable]').checked = showUnavailable;
    toolbar.querySelectorAll('[data-p5-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.p5View === view)));
    const shown = cards.filter(card => !card.hasAttribute('data-p5-category-hidden') && (showUnavailable || card.dataset.p5Available === 'true')).length;
    setText(toolbar.querySelector('[data-p5-count]'), toolbar.dataset.countTemplate.replace('{shown}', shown).replace('{total}', cards.length));
    root.querySelector('[data-p5-empty]').hidden = shown > 0 || cards.length === 0;
  }
  function init() {
    document.querySelectorAll('[data-p5-catalogue]').forEach(updateCatalogue);
    document.querySelectorAll('.shopify-section--related-products').forEach(section => {
      const recommendations = section.querySelector('product-recommendations');
      if (!recommendations || recommendations.children.length) section.hidden = !section.querySelector('product-card');
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-p5-category-menu][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-p5-category-menu][open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  function enquiry(link, variant) {
    if (!link) return;
    link.hidden = Boolean(variant?.available);
    const subject = 'Availability: ' + link.dataset.productTitle;
    const page = link.dataset.productUrl + (variant?.id ? '?variant=' + variant.id : '');
    const body = ['Product: ' + link.dataset.productTitle, variant?.title && variant.title !== 'Default Title' ? 'Option: ' + variant.title : '', 'Page: ' + page, 'Delivery country:'].filter(Boolean).join('\n');
    link.href = 'mailto:info@phase5boards.eu?' + new URLSearchParams({subject, body});
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-p5-show-unavailable]')) {
      showUnavailable = event.target.checked;
      document.querySelectorAll('[data-p5-catalogue]').forEach(updateCatalogue);
    }

  });
  document.addEventListener('variant:change', event => {
    enquiry(event.target.querySelector('[data-p5-enquiry]'), event.detail.variant);
  });
  const contact = document.getElementById('p5-live-contact');
  const newsletter = document.getElementById('p5-live-newsletter');
  const wishlist = document.getElementById('p5-live-wishlist');
  const openers = new WeakMap();
  function openDialog(dialog, opener) {
    if (!dialog || dialog.open) return;
    openers.set(dialog, opener);
    dialog.showModal();
  }
  [contact, newsletter, wishlist].filter(Boolean).forEach(dialog => {
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => openers.get(dialog)?.focus());
  });
  document.addEventListener('click', event => {
    const contactTrigger = event.target.closest('[data-p5-open-contact]');
    if (contactTrigger) openDialog(contact, contactTrigger);
    const newsletterTrigger = event.target.closest('[data-p5-open-newsletter]');
    if (newsletterTrigger) openDialog(newsletter, newsletterTrigger);
    const viewButton = event.target.closest('[data-p5-view]');
    if (viewButton) {
      view = viewButton.dataset.p5View;
      try { localStorage.setItem('p5-live-view', view); } catch (_) {}
      document.querySelectorAll('[data-p5-catalogue]').forEach(updateCatalogue);
    }
    const link = event.target.closest('a[href]');
    if (link && !link.hasAttribute('data-p5-direct-email') && /^mailto:(info@phase5boards\.eu|phase5europe@gmail\.com|phase5middleeast@gmail\.com)(\?|$)/i.test(link.getAttribute('href'))) {
      event.preventDefault();
      wishlist?.close();
      const params = new URLSearchParams(link.getAttribute('href').split('?')[1] || '');
      const draft = {subject:params.get('subject') || 'Store enquiry',body:params.get('body') || 'Page: ' + location.origin + location.pathname,time:Date.now()};
      try { sessionStorage.setItem('p5-live-contact-draft', JSON.stringify(draft)); } catch (_) {}
      contact.querySelector('[data-p5-direct-email]').href = 'mailto:info@phase5boards.eu?' + new URLSearchParams({subject:draft.subject,body:draft.body});
      const message = contact.querySelector('[name="contact[body]"]');
      if (message) message.value = [draft.subject,draft.body].filter(Boolean).join('\n\n');
      openDialog(contact, link);
    }
    const wish = event.target.closest('a[href="#swym-wishlist"],button.swym-add-to-wishlist-view-product');
    if (wish) {
      setTimeout(() => {
        const visible = [...document.querySelectorAll('.swym-ui-component,.swym-modal,.swym-notification-wishlist')].some(node => node.getBoundingClientRect().height > 20 && getComputedStyle(node).visibility !== 'hidden' && getComputedStyle(node).display !== 'none');
        if (!visible && !wish.classList.contains('swym-added')) openDialog(wishlist, wish);
      }, 1800);
    }
  });
  if (location.pathname.endsWith('/pages/contact')) {
    let draft;
    const params = new URLSearchParams(location.search);
    if (params.has('message')) draft = {subject:params.get('subject'),body:params.get('message')};
    else try {
      const saved = JSON.parse(sessionStorage.getItem('p5-live-contact-draft') || 'null');
      if (saved && Date.now() - saved.time < 1800000) draft = saved;
    } catch (_) {}
    const message = document.querySelector('[name="contact[body]"]');
    if (draft && message && !message.value) {
      message.value = [draft.subject,draft.body].filter(Boolean).join('\n\n');
      message.dispatchEvent(new Event('input',{bubbles:true}));
      try { sessionStorage.removeItem('p5-live-contact-draft'); } catch (_) {}
    }
  }
  function normaliseLinks() {
    document.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      let updated = href.trim().replace(/phase5europe@gmail\.com|phase5middleeast@gmail\.com/gi,'info@phase5boards.eu');
      if (/^info@phase5boards\.eu$/i.test(updated)) updated = 'mailto:info@phase5boards.eu';
      if(updated==='/collections/skim')updated='/collections/boards?p5_category=skim';
      if(updated==='/collections/surf')updated='/collections/boards?p5_category=surf';
      if(['/search?view=board-finder','/search?view=p5-board-guide','/pages/board-guide'].includes(updated))updated=document.body.dataset.p5GuideUrl||'/search?view=p5-board-guide';
      if (updated !== href) {
        link.setAttribute('href', updated);
        if (/^phase5(europe|middleeast)@gmail\.com$/i.test(link.textContent.trim())) link.textContent = 'info@phase5boards.eu';
      }
    });
  }
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; init(); normaliseLinks(); });
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load', init);
  init();
  normaliseLinks();
})();
